type methodType = 'DELETE' | 'PATCH' | 'POST' | 'GET' | 'PUT';

const url = import.meta.env.VITE_API_URL ?? 'localhost:8080';
const basePrefix = url.includes('localhost') ? 'http' : 'https';
const base = `${basePrefix}://${url}`;

async function doFetch(method: methodType, url: string, params?: Record<string, unknown>) {
  url = url[0] !== '/' && !url.startsWith('http') ? `/${url}` : url;

  let response = await fetch(`${base}${url}`, {
    headers: {
      Authorization: localStorage.getItem('authToken') || '',
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: method === 'GET' || method === 'DELETE' ? null : JSON.stringify(params),
    method,
  });

  const status = response.status;

  try {
    response = await response.json();
  } catch {}

  if (status !== 200 && status !== 201) {
    throw response;
  }

  return response as any;
}

const api = {
  patch: (url: string, params?: Record<string, unknown>) => doFetch('PATCH', url, params),
  post: (url: string, params?: Record<string, unknown>) => doFetch('POST', url, params),
  delete: (url: string) => doFetch('DELETE', url),
  get: (url: string) => doFetch('GET', url),
};

export default api;
